module.exports = __webpack_public_path__ + "assets/c59cd45533e4d40fc00d087817a64d3b.mp3";